import FleetManagement from "./fleet/FleetManagement";

/**
 * Submenú: Documentos y Vigencia → Documentos
 * Wrapper del módulo fleet — tabla principal de documentos
 * con filtros, drawer de detalle, wizard de renovación y KPIs
 */
const Documentos = () => {
  return <FleetManagement />;
};

export default Documentos;
